import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n";
import { LenisProvider, useLenis } from "@/lib/lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Activities from "@/pages/Activities";
import Partnerships from "@/pages/Partnerships";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    return this.state.err ? (
      <div className="flex min-h-screen items-center justify-center bg-obsidian p-8 font-mono text-sm text-tx2">
        Une erreur est survenue — rechargez la page.
      </div>
    ) : (
      this.props.children
    );
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);
  return null;
}

function Shell() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qui-sommes-nous" element={<About />} />
          <Route path="/nos-activites" element={<Activities />} />
          <Route path="/partenariats" element={<Partnerships />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <LenisProvider>
        <BrowserRouter>
          <ErrorBoundary>
            <ScrollToTop />
            <Shell />
          </ErrorBoundary>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0F131C",
              border: "1px solid rgba(0,255,135,.35)",
              color: "#F8FAFC",
            },
          }}
        />
      </LenisProvider>
    </LanguageProvider>
  );
}
